export function track(action, category, label, value) {
	if ('gtag' in window)
		gtag('event', action, {
			event_category: category,
			event_label: label,
			value: value
		})
}

export function facebookPixelTracking(id) {
	!(function(f, b, e, v, n, t, s) {
		if (f.fbq) return
		n = f.fbq = function() {
			n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
		}
		if (!f._fbq) f._fbq = n
		n.push = n
		n.loaded = !0
		n.version = '2.0'
		n.queue = []
		t = b.createElement(e)
		t.async = !0
		t.src = v
		s = b.getElementsByTagName(e)[0]
		s.parentNode.insertBefore(t, s)
	})(
		window,
		document,
		'script',
		'https://connect.facebook.net/en_US/fbevents.js'
	)
	fbq('init', id)
	fbq('track', 'PageView')
}
export function googleAnalyticsTracking(
	id,
	initialTitle,
	initialPath,
	pageViewStream,
	cookiesStream
) {
	const gtagElement = document.createElement('script')
	gtagElement.async = true
	gtagElement.src = 'https://www.googletagmanager.com/gtag/js?id=' + id
	const scriptElements = document.getElementsByTagName('script')
	const lastScriptElement = scriptElements[scriptElements.length - 1]
	lastScriptElement.parentNode.insertBefore(
		gtagElement,
		lastScriptElement.nextSibling
	)
	window.dataLayer = window.dataLayer || []
	window.gtag = function() {
		dataLayer.push(arguments)
	}
	gtag('js', new Date())
	gtag('config', id, {
		page_path: initialPath,
		page_title: initialTitle,
		anonymize_ip: !cookiesStream()
	})
	pageViewStream.map(({path, title}) => {
		gtag('event', 'page_view', {
			page_path: path,
			page_title: title,
			anonymize_ip: !cookiesStream()
		})
	})
}

export function gtmTracking(initialTitle, initialPath, pageViewStream) {
	var data = {
		event: 'VirtualPageview',
		virtualPageURL: initialPath,
		virtualPageTitle: initialTitle,
		anonymize_ip: true
	}
	window.dataLayer.push(data)

	pageViewStream.map(({path, title}) => {
		var data = {
			event: 'VirtualPageview',
			virtualPageURL: path,
			virtualPageTitle: title,
			anonymize_ip: true
		}
		window.dataLayer.push(data)
	})
}
